import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from "moment";
import _ from 'lodash';

@Injectable()
export class UtilityProvider {

  constructor(public http: HttpClient) {
    console.log('Hello UtilityProvider Provider');
  }

  public formatDate(date, format) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format(format);
  }

}



// WEBPACK FOOTER //
// ./src/providers/utility/utility.ts